import Blog_Details_Page from "@/components/blogs/blog-details-page";
import SeoHead from "@/components/ui/seoHead/seoHead";
import { setNewsDetailsData } from "@/store/corporate_slices/news_details_slice";
import { fetchData, SITE_URL } from "@/utils/api";
import { commonData } from "@/utils/commonData";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import NotFound from "../404";
import Head from "next/head";
import { formatTitle, generateBreadcrumbSchema } from "@/utils/constants";
import { notFound } from "next/navigation";

export const getServerSideProps = commonData(async (context) => {
  try {
    const queryParams = context.query;
    const resolvedUrl = context.resolvedUrl;
    const cleanResolvedUrl = resolvedUrl.startsWith("/")
      ? resolvedUrl.substring(1)
      : resolvedUrl;

    const queryString = Object.entries(queryParams)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    const endpoint = `corporate/news_details?${queryString}`;
    const blogDetailsUrl = SITE_URL.concat(cleanResolvedUrl);

    const result = await fetchData(endpoint);
    const data = result?.data || null;
    if (!data) {
      return {
        notFound: true,
      };
    }
    return { props: { data, blogDetailsUrl, currentUrl: resolvedUrl } };
  } catch (error) {
    console.error("Error fetching data:", error);
    return {
      notFound: true,
    };
  }
});

const Blog_Details_Main = ({ data, blogDetailsUrl, currentUrl }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (data) {
      dispatch(setNewsDetailsData(data));
    }
  }, [data, dispatch]);

  if (!data) {
    return <NotFound />;
  }
  const breadcrumbData = [
    {
      title: "Blog",
      link: "/blog",
    },
    {
      title: data ? formatTitle(data?.title) : "",
    },
  ];
  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              generateBreadcrumbSchema(breadcrumbData, currentUrl)
            ),
          }}
        />
      </Head>
      {data && (
        <SeoHead
          meta_title={data?.meta_title}
          meta_description={data?.meta_description}
          robots={data?.robots}
          canonical_url={data?.canonical_url}
          meta_keywords={data?.meta_keywords}
          og_description={data?.meta_description}
          og_image={data?.banner}
          og_title={data?.meta_title}
          page_name={data?.page_name}
          slug={data?.slug}
          twitter_title={data?.twitter_title}
          twitter_description={data?.twitter_description}
          twitter_image={data?.twitter_image}
        />
      )}
      {blogDetailsUrl && data && (
        <Blog_Details_Page
          blogDetailsUrl={blogDetailsUrl}
          newsDetalsApiData={data}
        />
      )}
    </>
  );
};

export default Blog_Details_Main;
